import { useTranslation } from 'react-i18next'
import { InformationFilled } from '@carbon/icons-react'

const MessagesModal = ({
  isOpen,
  brand,
  handleCloseModal,
}: {
  isOpen: boolean
  onClose: () => void
  brand: string
  handleAccept: () => void
  handleCloseModal: () => void
}) => {
  const { t } = useTranslation()

  return (
    isOpen && (
      <div
        className={`fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 font-aeonik`}
      >
        <div className="bg-white px-6 py-4 rounded-lg shadow-lg relative w-[358px] md:w-[768px] h-[auto]">
          <div className="flex flex-col justify-between h-full text-[20px]">
            {t('zoom.noCamModalGeneric.title')}
          </div>
          <p className="font-bold text-[20px] leading-7 text-[#00918A] font-aeonik flex items-center justify-center my-[24px]">
            <InformationFilled width={42} height={42} />
          </p>
          <p className="text-[20px] mb-6 leading-7 text-generic-neutral-900 font-aeonik">
            {t('zoom.noCamModalGeneric.description')}
          </p>
          <div className="flex justify-end items-center">
            <button
              onClick={handleCloseModal}
              className={`mt-6 text-[14px] py-2 px-10  text-[#E6E9EC] rounded-lg ${
                brand === 'vidacaixa'
                  ? 'bg-[#007EAE] hover:bg-[#036085] focus:bg-[#007EAE] focus:ring-4 focus:ring-[#cce5f0] focus:outline-none'
                  : 'bg-generic-primary-500 hover:bg-generic-primary-400 focus:bg-generic-primary-500 focus:ring-4 focus:ring-generic-primary-200 focus:outline-none'
              }`}
            >
              {t('zoom.acceptanceScreen.accept')}
            </button>
          </div>
        </div>
      </div>
    )
  )
}

export default MessagesModal
